<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
    <div class="container">
      <router-link class="navbar-brand" to="/">Simplex</router-link>
      <button
          @click="toggleMenu"
          class="navbar-toggler"
          type="button"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" :class="{'show':isShow}" id="navbarResponsive">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item" v-for="item in menu" :key="item._id">
            <router-link class="nav-link" :to="item.to">{{item.linkName}}</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link lang-link" :to="{query: {lang: 'en'}}">
              <img :src="enFlag" alt="" :class="{active: activeLang === 'en'}">
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link lang-link" :to="{query: {lang: 'gr'}}">
              <img :src="grFlag" alt="" :class="{active: activeLang === 'gr'}">
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import EnFlag from '@/assets/en.svg';
import GrFlag from '@/assets/gr.svg';
import store from '@/store';
import Api from '@/api';
import filterObject from '@/util/lang';

export default {
  name: 'Menu',
  component: {
    EnFlag,
    GrFlag,
  },
  data() {
    return {
      isShow: false,
      enFlag: '',
      grFlag: '',
      menu: [
        { to: '/', linkName: 'Home', _id: 1 },
        { to: '/products', linkName: 'Products', _id: 2 },
        { to: '/about', linkName: 'About us', _id: 3 },
        { to: '/contacts', linkName: 'Contacts', _id: 4 },
      ],
    };
  },
  created() {
    this.enFlag = require('@/assets/en.svg');
    this.grFlag = require('@/assets/gr.svg');
    this.getMenuItems();
    store.watch(
      state => state.lang,
      () => {
        this.getMenuItems();
      },
    );
  },
  watch: {
    $route() {
      this.isShow = false;
    },
  },
  computed: {
    activeLang() {
      return store.getters.lang;
    },
  },
  methods: {
    getMenuItems() {
      Api.getMenuItems()
        .then(menu => menu.map(item => filterObject(item, store.getters.lang)))
        .then(menu => {
          this.menu = menu;
        });
    },
    toggleMenu() {
      this.isShow = !this.isShow;
    },
  },
};
</script>

<style lang="scss">
.router-link-exact-active {
  color: #fff !important;
}
.lang-link img {
  width: 32px;
  height: auto;
  filter: grayscale(100%);
  opacity: 0.65;
  &.active {
    opacity: 1;
    filter: none;
  }
}
</style>
